import { jsx } from "react/jsx-runtime";
import { string, node, arrayOf, oneOfType, oneOf } from "prop-types";
import React from "react";
import cx from "classnames";
const propTypes = {
  /** Array of nodes (\*) */
  children: oneOfType([
    /** Array of elements. */
    arrayOf(node),
    /** One or more elements without array. */
    node
  ]),
  /** Prefix all classes in every element with this string */
  prefix: string,
  /** Applies custom class name attribute for the tag. */
  className: string,
  /** Wrapper element tag name for children */
  tagName: oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "span", "p", ""]),
  /** Applies heading size for the text component */
  headingSize: oneOf(["xl", "l", "m", "s", "xs"]),
  /** Applies body size for the text component */
  bodySize: oneOf(["xl", "l", "m", "s"])
};
const Text = (props) => {
  const {
    prefix = "",
    className,
    tagName,
    headingSize,
    bodySize = "m",
    children,
    ...other
  } = props;
  const baseClass = `${prefix}text`;
  const classes = cx(
    baseClass,
    headingSize && `${baseClass}--heading-${headingSize}`,
    !headingSize && bodySize && `${baseClass}--body-${bodySize}`,
    className
  );
  const Tag = tagName;
  return tagName ? /* @__PURE__ */ jsx(Tag, { ...other, className: classes, children }) : /* @__PURE__ */ jsx("div", { ...other, className: classes, children });
};
Text.propTypes = propTypes;
var Text_default = Text;
export {
  Text_default as default
};
